import { ICompetitionWatchlistPair, enums } from '@kattana-io/common';
import Text from '../../../atoms/Text';
import { decorateExchangeName } from '../../../helpers/decorators';
import { capitalize } from '../../Modal/TickersModal/helpers';

interface ICompetitionTickerMobileProps {
  item: ICompetitionWatchlistPair;
  enabled: boolean;
  multiplier: number;
}

const CompetitionTickerMobile = ({
  item,
  enabled,
  multiplier,
}: ICompetitionTickerMobileProps) => {
  const exchange = capitalize(decorateExchangeName(item.exchange, item.chain));
  return (
    <div className='ticker__cell'>
      <div className='name_exchange'>
        <Text size={14} className='text--weight-500 text--grey-400'>
          {item.name}&nbsp;
          <Text size={14} className='text--green-600'>
            x{multiplier} pts
          </Text>
        </Text>
        {enabled ? (
          <div className='watchlist__row__exchange watchlist__row__exchange--enabled'>
            <Text size={12} className='text--weight-500 text--grey-600'>
              {exchange}
            </Text>
            <div className='watchlist__row__exchange__icon icon-check-circle' />
          </div>
        ) : (
          <div className='watchlist__row__exchange watchlist__row__exchange--disabled'>
            <Text size={12} className='text--weight-500 text--grey-600'>
              {exchange}
            </Text>
            <div className='watchlist__row__exchange__icon icon-alert-triangle' />
          </div>
        )}
      </div>
    </div>
  );
};

export default CompetitionTickerMobile;
